import type { IconProps } from "../Icon.props";
import createWebIcon from "../createWebIcon";
import validateKeys from "../validateKeys";

export default function Graph({ outline, ...props }: IconProps): JSX.Element {
  return outline ? <Graph.Outline {...props} /> : <Graph.Solid {...props} />;
}

Graph.Outline = function Outline({ name, ...props }: IconProps) {
  const Icon = createWebIcon({
    ...props,
    name: `${name}Outline`,
    path: (
      <>
        {/**
         * Enter the contents of your SVG here without the <svg> tag.
         * For outlined icons, be sure to add `className="icon-outline"`
         * to each path that needs to be outlined.
         */}
      </>
    ),
  });

  return <Icon {...validateKeys(props)} />;
};

Graph.Solid = function Solid({ name, ...props }: IconProps) {
  const Icon = createWebIcon({
    ...props,
    name: `${name}Solid`,
    path: (
      <>
        <path
          d="M10.1528 6.05534C10.2037 6.15901 10.2373 6.27003 10.2524 6.38415L10.5308 10.5241L10.669 12.6049C10.6705 12.8189 10.704 13.0315 10.7687 13.2359C10.9356 13.6324 11.3372 13.8844 11.7741 13.8668L18.4313 13.4314C18.7196 13.4266 18.998 13.5344 19.2052 13.7311C19.3779 13.895 19.4894 14.1094 19.5246 14.34L19.5364 14.48C19.2609 18.2947 16.4592 21.4765 12.6524 22.2978C8.84555 23.1191 4.94186 21.3841 3.06071 18.0347C2.51839 17.0616 2.17965 15.9921 2.06438 14.8888C2.01623 14.5622 1.99503 14.2323 2.00098 13.9024C1.99503 9.81255 4.90747 6.27677 8.98433 5.42438C9.47501 5.34798 9.95603 5.60774 10.1528 6.05534Z"
          className="icon-primary"
        />
        <path
          opacity="0.4"
          d="M12.8701 2.50082C17.43 2.61683 21.2624 5.89579 22.0001 10.3123L21.993 10.3449L21.9729 10.3923L21.9757 10.5224C21.9652 10.6947 21.8987 10.8605 21.784 10.9945C21.6646 11.134 21.5014 11.229 21.3217 11.2659L21.2121 11.2809L13.5313 11.7786C13.2758 11.8038 13.0214 11.7214 12.8314 11.552C12.6731 11.4107 12.5719 11.2201 12.5433 11.0147L12.0277 3.34506C12.0188 3.31913 12.0188 3.29102 12.0277 3.26508C12.0348 3.05367 12.1278 2.85384 12.2861 2.71023C12.4444 2.56662 12.6547 2.4912 12.8701 2.50082Z"
          className="icon-secondary"
        />
      </>
    ),
  });

  return <Icon {...validateKeys(props)} />;
};
